export * from "./center";
export * from "./magiceden";
export * from "./moralis";
export * from "./opensea";
export * from "./solscan";
export var NFTApiProvider;
(function (NFTApiProvider) {
    NFTApiProvider["OPENSEA"] = "opensea";
    NFTApiProvider["MORALIS"] = "moralis";
    NFTApiProvider["MAGICEDEN"] = "magiceden";
    NFTApiProvider["SIMPLEHASH"] = "simplehash";
    NFTApiProvider["SOLSCAN"] = "solscan";
    NFTApiProvider["CENTER"] = "center";
})(NFTApiProvider || (NFTApiProvider = {}));
